module.exports = __webpack_public_path__ + "img/banner100kata2021-min.32b517c3.jpg";